import PropTypes from 'prop-types';
import React from 'react';

import { Flex, Box } from 'reflexbox';

import {
  If,
} from 'frontend/components';

import config from 'frontend/config';

const BannerAlertText = ({ message, linkText, linkUrl }) => {
  if (!message && !linkText) {
    return null;
  }

  let margin = 0;
  let separator = false;
  if (message && linkText && linkUrl) {
    margin = 1;
    separator = true;
  }

  return (
    <Flex justify="center">
      <Box>
        {message}
      </Box>
      <If
        condition={separator}
        then={() => (
          <Box ml={margin}>
            &mdash;
          </Box>
        )}
      />
      <If
        condition={linkText && linkUrl}
        then={() => (
          <Box ml={margin}>
            <a
              href={linkUrl}
              rel="noopener noreferrer"
              target="_blank"
              style={{
                color: config.colors.black,
                textDecoration: 'underline',
              }}
            >
              {linkText}
            </a>
          </Box>
        )}
      />
    </Flex>
  );
};

BannerAlertText.propTypes = {
  message: PropTypes.string,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
};

BannerAlertText.defaultProps = {
  message: null,
  linkText: null,
  linkUrl: null,
};


export default BannerAlertText;
